export const RoutesParams = {
	id: 'id',
  venueId: 'venueId',
  seatPlanId: 'seatPlanId',
};

export const RoutesUrl = {
	welcome: '/',
  dashboard: '/dashboard',
  invCount: {
	  root: '/invcount',
    byId: (id) => `${RoutesUrl.invCount.root}/${id}`,
  },
  form: {
	  root: '/form',
    byId: (id) => `${RoutesUrl.form.root}/${id}`,
  },
  venueEditor: {
	  root: '/venue-editor',
    byId: (venueId) => `${RoutesUrl.venueEditor.root}/venues/${venueId}`,
    venueSeatPlans: (venueId) => `${RoutesUrl.venueEditor.root}/venues/${venueId}/seat-plans`,
    venueSeatPlanById: (venueId, seatPlanId) => `${RoutesUrl.venueEditor.root}/venues/${venueId}/seat-plans/${seatPlanId}`,
    venueSeatPlanEditor: (venueId, seatPlanId) => `${RoutesUrl.venueEditor.root}/venues/${venueId}/seat-plans/${seatPlanId}/seat-plan-editor`,
    venueSections: (venueId, seatPlanId) => `${RoutesUrl.venueEditor.root}/venues/${venueId}/seat-plans/${seatPlanId}/sections`,
    venueSectionById: (venueId, seatPlanId, sectionId) => `${RoutesUrl.venueEditor.root}/venues/${venueId}/seat-plans/${seatPlanId}/sections/${sectionId}`,
    venueSeatMap: (venueId, seatPlanId, sectionId) => `${RoutesUrl.venueEditor.root}/venues/${venueId}/seat-plans/${seatPlanId}/sections/${sectionId}/seat-map`,
  },
  seatSwap: {
    root: '/seat-swap',
  },
  filmHire: {
    root: '/film-hire',
    policy: `policy`,
    ticketSaleExport: `ticket-sale-data-export`,
    distributorExport: `distributor-export`,
    eventMaster: `event-master`,
    assignment: `assignment`,
    goToEventMaster: () => `${RoutesUrl.filmHire.root}/${RoutesUrl.filmHire.eventMaster}`,
    eventMasterByCode: (code) => `${RoutesUrl.filmHire.root}/${RoutesUrl.filmHire.eventMaster}/${code}`,
  },
  svEditor: {
    root: '/sv-editor',
    byId: (svId) => `${RoutesUrl.svEditor.root}/svs/${svId}`,
  },
  ticketLayout: {
    root: '/ticket-layout',
    byId: (printLayoutId) => `${RoutesUrl.ticketLayout.root}/${printLayoutId}`,
  },
	session: {
	  root: 'session',
		signIn: `/session/signin`,
		signUp: `/session/signup`,
		forgot: '/session/forgot',
	},
};
